import z, { boolean, number, object, string, union } from "zod";

import { LadyMinV2MainPhotoDTORaw } from "@/models/lady-dtos";
import { Prettify } from "@/models/utils.models";

export const SignInFormSchema = object({
  username: string(),
  userpass: string(),
});

export type SignInFormSchema = z.infer<typeof SignInFormSchema>;

export const SignInResponseDtoError = object({
  error: string(),
});

export type SignInResponseDtoError = z.infer<typeof SignInResponseDtoError>;

export const SignInResponseDtoResult = object({
  result: object({
    id: number(),
    mainPhotoDto: LadyMinV2MainPhotoDTORaw.optional(),
    online: boolean().optional(),
  }),
});

export type SignInResponseDtoResult = z.infer<typeof SignInResponseDtoResult>;

export const SignInResponseDto = union([
  SignInResponseDtoResult,
  SignInResponseDtoError,
]);

export type SignInResponseDto = Prettify<z.infer<typeof SignInResponseDto>>;
